import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import '@awesome.me/webawesome/dist/components/radio-group/radio-group.js';
import '@awesome.me/webawesome/dist/components/radio/radio.js';
import type WaRadioGroup from '@awesome.me/webawesome/dist/components/radio-group/radio-group.js';

import { nsSharedStyles } from '../ns-styles/index.js';

@customElement('ns-env-picker')
export class NSEnvPicker extends LitElement {
  @property({ type: String })
  service = '';

  @property({ type: String, attribute: 'live-label' })
  liveLabel = 'Live';

  @property({ type: String, attribute: 'sandbox-label' })
  sandboxLabel = 'Sandbox';

  @property({ type: String, attribute: 'live-value' })
  liveValue = 'LIVE';

  @property({ type: String, attribute: 'sandbox-value' })
  sandboxValue = 'SANDBOX';

  @property({ type: String })
  value = '';

  static styles = [
    nsSharedStyles,
    css`
      :host {
        display: block;
      }
    `,
  ];

  private __onChange(e: Event) {
    this.value = (e.target as WaRadioGroup).value as string;
    this.dispatchEvent(new CustomEvent('env-change', { detail: { value: this.value }, bubbles: true, composed: true }));
  }

  render() {
    return html`
      <wa-radio-group .value=${this.value} @change=${this.__onChange}>
        <div slot="label" class="mb-3">${this.service} environment (choose one)</div>
        <wa-radio value=${this.liveValue}>${this.liveLabel}</wa-radio>
        <wa-radio value=${this.sandboxValue}>${this.sandboxLabel}</wa-radio>
      </wa-radio-group>
    `;
  }
}
